import ReactApexChart from "react-apexcharts";

const BarBasicChart = ({ seriesChart, categoriesChart, colorsChart, height }) => {


    var options = {
        chart: {
            height: height,
            type: 'bar',
            toolbar: { show: false, }
        },
        plotOptions: {
            bar: {
                horizontal: false,
                columnWidth: '45%',
                endingShape: 'rounded'
            },
        },
        dataLabels: {
            enabled: false
        },
        stroke: {
            show: true,
            width: 2,
            colors: ['transparent']
        },
        colors: colorsChart,
        xaxis: {
            categories: categoriesChart,
        },
        grid: {
            borderColor: '#f1f1f1',
        },
        fill: {
            opacity: 1

        },
    };


    return (
        <ReactApexChart dir="ltr" className="apex-charts"
            series={seriesChart}
            options={options}
            type="bar"
            height={height}
        />
    );
};

export default BarBasicChart;